import React, {Fragment} from 'react';

import {Card, Stack} from '@mui/material';
import {MainFooter, MainHeader} from 'presentation/components';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {ActionButtons} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/ActionButtons';
import {AppointmentAddress} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/AppointmentAddress';
import {AppointmentInfoList} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/AppointmentInfoList';
import {ConfirmationCTAButtons} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/ConfirmationCTAButtons';
import {SuccessHeader} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/SuccessHeader';
import {PrintTemplateNew} from 'presentation/modules/booking/shared/ui/components/PrintTemplateNew';
import {translations} from 'presentation/translations-new';
import {useExamConfirmationBookingContent} from './hooks/useExamConfirmationBookingContent';
import {StyledContainer, StyledFooterBox} from './styles';
import {ExamConfirmationBookingContentProps} from './types';
import {ExamInstructionsAlert} from './components/ExamInstructionsAlert';

const {confirmationBooking} = translations['pt-br'].privateFlow.bookingFlow;

export function ExamConfirmationBookingContentNew({
	bookedAppointment,
	goToMyAppointments,
	isAdvanceDiagnosticsExam,
}: ExamConfirmationBookingContentProps) {
	const {
		isMobile,
		isPrinting,
		isSharing,
		printContent,
		printRef,
		calendarEvent,
		date,
		hour,
		providerName,
		specialtyName,
		protocolNumber,
		beneficiaryName,
		planName,
		goToHome,
		shareContent,
		handleOpenGoogleMaps,
		formattedAddress,
		clinicName,
		specialtyCode,
		addressForMaps,
	} = useExamConfirmationBookingContent(bookedAppointment);

	return (
		<Fragment>
			<MainHeader
				title={confirmationBooking}
				handleClose={goToHome}
				hideBackBtn
				variant="subRoute"
			/>

			<StyledContainer>
				<Card elevation={0} sx={{borderRadius: 2, p: 3}}>
					<Stack gap={3}>
						<SuccessHeader flowType={FlowEnum.EXAM} />

						<AppointmentInfoList
							beneficiaryName={beneficiaryName}
							planName={planName}
							providerName={providerName}
							specialtyName={specialtyName}
							clinicName={clinicName}
							date={date}
							hour={hour}
							protocolNumber={protocolNumber}
							flowType={FlowEnum.EXAM}
							isAdvanceDiagnosticsExam={isAdvanceDiagnosticsExam}
						/>

						<ActionButtons
							isMobile={isMobile}
							isPrinting={isPrinting}
							printContent={printContent}
							shareContent={shareContent}
							calendarEvent={calendarEvent}
							isSharing={isSharing}
						/>

						<AppointmentAddress
							formattedAddress={formattedAddress}
							addressForMaps={addressForMaps}
							handleOpenMap={handleOpenGoogleMaps}
						/>

						<ExamInstructionsAlert
							examName={specialtyName}
							examNumber={String(specialtyCode ?? '')}
						/>
					</Stack>
				</Card>

				<ConfirmationCTAButtons
					goToMyAppointments={goToMyAppointments}
					goToHome={goToHome}
					isMobile={isMobile}
				/>
			</StyledContainer>

			<StyledFooterBox>
				<MainFooter />
			</StyledFooterBox>

			<PrintTemplateNew
				bookedAppointment={bookedAppointment}
				flowType={FlowEnum.EXAM}
				printRef={printRef}
				isAdvanceDiagnosticsExam={isAdvanceDiagnosticsExam}
			/>
		</Fragment>
	);
}
